import { createFileRoute } from '@tanstack/react-router';

import { AddLocation } from 'features/locations/AddLocation';

export const Route = createFileRoute('/_authenticated/locations/add/')({
  component: AddLocation
});
